import React, { useContext } from 'react';
import { useNoVehicle } from '../TileKit/hooks';
import { TileKitContext } from '../TileKit/TileKit';
import './MakeModel.scss';

const useYearMakeModel = () => {
  const { vehicle } = useContext(TileKitContext);

  return {
    year: vehicle?.year,
    make: vehicle?.make,
    model: vehicle?.model
  };
};

const MakeModelSkeleton: React.FC = ({ children }) => {
  const noVehicle = useNoVehicle();

  if (noVehicle) {
    return (
      <div className="make-model skeleton">
        <div className="year-make" />
      </div>
    );
  }
  return <>{children}</>;
};

const MakeModel: React.VFC = () => {
  const { year, make, model } = useYearMakeModel();

  return (
    <MakeModelSkeleton>
      <div className="make-model" data-qa="make-model">
        <div className="year-make">
          {year} {make} {model}
        </div>
      </div>
    </MakeModelSkeleton>
  );
};

export default MakeModel;
